import React, { useContext, useEffect } from 'react';
import AppContext from 'contexts/appContext';

export default function AccountSettings(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Account, 'Manage Account');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Account', href: '/Account/Manage' }, { name: 'Settings', selected: true }]);
  }, []);

  return (
    <div className='container mt-3'>
      Settings
    </div>
  );
}